export const validateName = (name: string) => {
  const nameRegex = /^[A-Za-zÀ-ÿ\s]{2,50}$/;
  return nameRegex.test(name);
};

export const validateEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};